import { motion } from "framer-motion";
import { fadeUp, stagger, cardAnimation } from "./animations";

export default function TechnologyWhy() {
  return (
    <section
      className="
        bg-white
        py-20
        sm:py-24
        lg:py-28
      "
    >
      <div
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
          }}
          className="
            grid
            gap-10
            lg:grid-cols-[0.8fr_1.2fr]
            lg:gap-20
          "
        >
          <div>
            <SectionLabel>Why WE3X</SectionLabel>

            <h2
              className="
                merriweather
                mt-5
                text-3xl
                font-black
                tracking-[-0.04em]
                sm:text-4xl
                lg:text-[52px]
                lg:leading-[1.08]
              "
            >
              Technology should solve
              <span className="block text-[#55aef3]">a real problem.</span>
            </h2>

            <p
              className="
                mt-6
                max-w-lg
                text-[15px]
                leading-8
                text-neutral-600
              "
            >
              We combine design thinking, development and digital strategy so
              your business does not have to work with disconnected teams for
              every stage of a project.
            </p>
          </div>

          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
            }}
            className="
              border-t
              border-neutral-200
            "
          >
            <WhyRow
              number="01"
              title="Built Around Your Business"
              text="We understand the requirement first and choose the technology after."
            />

            <WhyRow
              number="02"
              title="Design With Purpose"
              text="Every screen and interaction should make the experience clearer and easier."
            />

            <WhyRow
              number="03"
              title="Development That Can Grow"
              text="We build systems with future expansion, performance and maintainability in mind."
            />

            <WhyRow
              number="04"
              title="One Team. Multiple Capabilities."
              text="Software, apps, design, marketing, animation and content connected under one team."
              last
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

function SectionLabel({ children, dark = false }) {
  return (
    <div
      className={`
        flex
        items-center
        gap-3
        text-[10px]
        font-bold
        uppercase
        tracking-[0.2em]
        ${dark ? "text-[#55aef3]" : "text-[#3899e4]"}
      `}
    >
      <span className="h-[1px] w-8 bg-[#55aef3]" />

      {children}
    </div>
  );
}

function WhyRow({ number, title, text, last = false }) {
  return (
    <motion.div
      variants={cardAnimation}
      className={`
        grid
        gap-4
        py-7
        sm:grid-cols-[70px_1fr]
        ${!last ? "border-b border-neutral-200" : ""}
      `}
    >
      <span
        className="
          font-mono
          text-xs
          font-bold
          text-[#55aef3]
        "
      >
        {number}
      </span>

      <div>
        <h3
          className="
            merriweather
            text-xl
            font-bold
          "
        >
          {title}
        </h3>

        <p
          className="
            mt-2
            max-w-xl
            text-sm
            leading-7
            text-neutral-500
          "
        >
          {text}
        </p>
      </div>
    </motion.div>
  );
}
